export const CHUNK_RELOAD_FLAG_KEY = 'mingo_chunk_reloaded';

/** After one auto-reload, suppress further auto-reloads for this tab session window. */
const CHUNK_RELOAD_COOLDOWN_MS = 24 * 60 * 60 * 1000;

/** @param {unknown} error */
export function isChunkLoadError(error) {
  if (!error || typeof error !== 'object') return false;
  const name = String(/** @type {{ name?: string }} */ (error).name || '');
  const message = String(/** @type {{ message?: string }} */ (error).message || '');
  if (name === 'ChunkLoadError') return true;
  if (/Loading chunk [\w-]+ failed/i.test(message)) return true;
  if (/Failed to fetch dynamically imported module/i.test(message)) return true;
  return false;
}

/**
 * True while a recent auto-reload is in cooldown (or legacy flag `1` is set).
 * Do NOT clear this on SessionGate boot — that re-arms infinite reload loops on
 * cold lazy routes like `/search` after a deploy when chunks stay stale.
 */
export function hasChunkReloadFlag() {
  if (typeof sessionStorage === 'undefined') return false;
  const raw = sessionStorage.getItem(CHUNK_RELOAD_FLAG_KEY);
  if (!raw) return false;
  if (raw === '1') return true;
  const ts = Number(raw);
  if (!Number.isFinite(ts)) return true;
  return Date.now() - ts < CHUNK_RELOAD_COOLDOWN_MS;
}

/** @param {unknown} error @returns {boolean} true if a guarded reload was triggered */
export function tryChunkReloadOnce(error) {
  if (!isChunkLoadError(error) || hasChunkReloadFlag()) return false;
  try {
    sessionStorage.setItem(CHUNK_RELOAD_FLAG_KEY, String(Date.now()));
  } catch {
    /* quota / private mode */
  }
  window.location.reload();
  return true;
}

export function clearChunkReloadFlag() {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_FLAG_KEY);
  } catch {
    /* ignore */
  }
}

/** Catches dynamic import failures that bypass ErrorBoundary (unhandled promise rejections). */
export function installChunkReloadGuard() {
  if (typeof window === 'undefined') return;
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (tryChunkReloadOnce(reason)) {
      event.preventDefault();
    }
  });
}
